module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/additional-briefing-clan-landing-elite-big.5f2f7470.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/additional-briefing-clan-landing-elite-big.png
// module id = 3687
// module chunks = 11